import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Exclude, Expose } from 'class-transformer';
import { IsUUID } from 'class-validator';
import { PhotoDto } from '../../photo/dto/photo.dto';
import { JobPhaseBumpPhotoCommonInterface } from '../interfaces/job-phase-bump-photo-common.interface';
import { UserDto } from '../../user/dto/user.dto';
import { UserPublicInterface } from '../../user/interfaces/user-public.interface';

@Exclude()
export class JobPhaseBumpPhotoCommonDto
  extends PhotoDto
  implements JobPhaseBumpPhotoCommonInterface
{
  @ApiProperty({
    title: 'Deleted At',
  })
  @Expose()
  deletedAt?: Date;

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Associated User ID',
  })
  @IsUUID()
  @Expose()
  userId!: string;

  @ApiPropertyOptional({
    type: () => [UserDto],
    title: 'User',
    description: 'The user associated with this job phase bump photo.',
  })
  @Expose()
  user?: UserPublicInterface;
}
